import script from "./tutorOnboardingFifthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingFifthPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingFifthPage.vue?vue&type=style&index=0&id=fb0b540e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb0b540e"]])

export default __exports__